

export const sliderItems = [
    {
      id: 1,
      img: "https://firebasestorage.googleapis.com/v0/b/shop-d66d7.appspot.com/o/Discount50.png?alt=media&token=99522db0-04f4-41af-a89c-be88bad9a0fb",
      //img: iphone,
      title: "GET 50% DISCOUNT",
      desc: "Order 3 or more everyday cakes and get 50% discount",
      bg: "f5fafd",
    },
    {
      id: 2,
      img: "https://firebasestorage.googleapis.com/v0/b/shop-d66d7.appspot.com/o/EASTERCAKE.png?alt=media&token=e5e28715-d9b7-4920-ac79-aed68d083750",
      //img: iphone2,
      title: "EASTER CAKES",
      desc: "WE WILL MADE YOUR HOLIDAY TASTE",
      bg: "fcf1ed",
    },
    {
      id: 3,
      img: "https://firebasestorage.googleapis.com/v0/b/shop-d66d7.appspot.com/o/Discount50.png?alt=media&token=99522db0-04f4-41af-a89c-be88bad9a0fb",
      //img: iphone3,
      title: "GET 50% DISCOUNT",
      desc: "Order 3 or more everyday cakes and get 50% discount",
      bg: "fbf0f4",
    },
  ];

  export const categories = [
    {
      id: 1,
      img: "https://firebasestorage.googleapis.com/v0/b/shop-d66d7.appspot.com/o/BDcake.jpg?alt=media&token=1c5f82a1-a59f-4254-a89f-3ea8dc9bada4",
      //img: iphone,
      title: "BIRTHDAY CAKES",
      cat: "birthday",
    },
    {
      id: 2,
      img: "https://firebasestorage.googleapis.com/v0/b/shop-d66d7.appspot.com/o/Wcake.jpg?alt=media&token=f11ad00b-78bd-482b-9214-8f4e6bdf35e5",
      // img: iphone2,
      title: "WEDDING SETS",
      cat: "wedding",
    },
    {
      id: 3,
      img: "https://firebasestorage.googleapis.com/v0/b/shop-d66d7.appspot.com/o/EDcake.jpg?alt=media&token=b1d63b6b-a033-4203-b061-62ef75b69e16",
      // img: iphone3,
      title: "EVERYDAY CAKES",
      cat: "everyday",
    },
  ];

  export const popularProducts = [
    {
      id:1,
      img:"https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png",
    },
    {
      id:2,
      img:"https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png",
    },
    {
      id:3,
      img:"https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png",
    },
    {
      id:4,
      img:"https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png",
    },
    {
      id:5,
      img:"https://images.ctfassets.net/5gvckmvm9289/3BlDoZxSSjqAvv1jBJP7TH/65f9a95484117730ace42abf64e89572/Noissue-x-Creatsy-Tote-Bag-Mockup-Bundle-_4_-2.png",
    },
    {
      id:6,
      img:"https://d3o2e4jr3mxnm3.cloudfront.net/Rocket-Vintage-Chill-Cap_66374_1_lg.png",
    },
    {
      id:7,
      img:"https://www.pngarts.com/files/3/Women-Jacket-PNG-High-Quality-Image.png",
    },
    {
      id:8,
      img:"https://www.pngarts.com/files/3/Women-Jacket-PNG-High-Quality-Image.png",
    },
  ]